import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Tooltip from "@mui/material/Tooltip";
import CircularProgress from "@mui/material/CircularProgress";

import { Alert, Mode, SnackbarComponentVariant } from "packable-components";

import { SnackbarComponent } from "packable-components";

import { EntityDetails } from "packable-components";
import { logDebug } from "packable-components";
import { mergeProperties } from "packable-components";

import {
  IOrder,
  IOrderItem,
  IOrderProps,
  IOrderState,
  IShipmentItem,
  OrderEntity,
  OrderItemAction,
  OrderItemActionEntity,
  OrderStatus,
  OrderType,
  OrderUpdateRequest,
  OrderUpdateRequestEntity,
  ShippingStatus,
  StorageStatus,
} from "./Order.types";
import OrderHeader from "./OrderHeader";
import OrderItem from "./OrderItem";
import { Typography } from "@mui/material";
import { IPaymentProps, PaymentDetails, PaymentStatus } from "packable-common";

const defaultStyles = {
  OrderDetailsContainer: {},
  OrderDetailsDialog: {},
  OrderDetailsShowSpinner: {
    top: "calc(50% - 20px)",
    left: "calc(50% - 20px)",
    margin: "0 auto",
    position: "absolute",
    display: "block",
  },
  OrderDetailsHideSpinner: {
    display: "none",
  },
  OrderDetailsDialogTitle: {},
  OrderDetailsDialogTitleContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    pl: 1,
  },
  OrderDetailsDialogContent: {},
  OrderDetailsDialogContentContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  OrderDetailsDialogRowContainer: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "center",
  },
  OrderDetailsDialogSingleItemRowContainer: {
    width: "512px",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  OrderDetailsDialogContentShortTextFieldContainer: {
    padding: 1,
  },
  OrderDetailsDialogContentShortTextField: {
    width: "240px",
  },
  OrderDetailsDialogFullWidthTextFieldContainer: {
    width: "100%",
    padding: 1,
  },
  OrderDetailsDialogFullWidthTextField: {
    width: "100%",
  },
  OrderDetailsDialogActions: {
    margin: 3,
  },
  OrderDetailsDialogActionsContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    alignContent: "center",
  },
  OrderDetailsDialogActionsOrderPaymentButton: {
    muiColor: "primary",
    muiVariant: "outlined",
    ml: 1,
  },
  OrderDetailsDialogActionsDeleteButton: {
    muiColor: "secondary",
    muiVariant: "contained",
    ml: 1,
  },
  OrderDetailsDialogActionsPayButton: {
    muiColor: "primary",
    muiVariant: "contained",
    ml: 1,
  },
  OrderDetailsDialogActionsCancelButton: {
    muiVariant: "outlined",
    muiColor: "primary",
  },
  OrderDetailsDialogActionsSaveButton: {
    muiVariant: "contained",
    muiColor: "primary",
    ml: 1,
  },
  PackableAlertDialogBody: {
    display: "flex",
    flexDirection: "column",
    alignContent: "center",
    justifyContent: "center",
    width: "300px",
  },
  PackableAlertDialogTitleTypography: {
    muiVariant: "h6",
  },
  PackableAlertDialogOption1Button: {
    muiVariant: "outlined",
  },
  PackableAlertDialogOption2Button: {
    muiVariant: "contained",
  },
};

export class OrderDetails extends EntityDetails {
  state: IOrderState;
  updateOrderURL: string;
  deleteOrderURL: string;
  isAdmin: boolean;
  trackingNumbers: Array<string>;
  closeButtonLabel: string;
  closeButtonTooltip: string;
  cancelButtonLabel: string;
  cancelButtonTooltip: string;
  submitButtonLabel: string;
  submitButtonTooltip: string;
  orderPaymentButtonLabel?: string;
  orderPaymentButtonTooltip?: string;
  deleteButtonLabel: string;
  deleteButtonTooltip: string;
  payButtonLabel: string;
  payButtonTooltip: string;
  effectiveStyles: any;

  constructor(props: IOrderProps) {
    super(props);
    logDebug("OrderDetails PROPS");
    logDebug(props);

    this.effectiveStyles =
      props.styles === undefined
        ? defaultStyles
        : mergeProperties(defaultStyles, props.styles);

    logDebug("OrderDetails Effective Styles:");
    logDebug(this.effectiveStyles);

    this.updateOrderURL = props.updateOrderURL;
    this.deleteOrderURL = props.deleteOrderURL;
    this.isAdmin = props.isAdmin;
    this.trackingNumbers = [];
    this.closeButtonLabel = props.closeButtonLabel || "Close";
    this.closeButtonTooltip = props.closeButtonTooltip || "Close";
    this.cancelButtonLabel = props.cancelButtonLabel || "Cancel";
    this.cancelButtonTooltip = props.cancelButtonTooltip || "Cancel";
    this.submitButtonLabel = props.submitButtonLabel || "Submit";
    this.submitButtonTooltip =
      props.submitButtonTooltip || "Submit Order Updates";
    this.orderPaymentButtonLabel = props.orderPaymentButtonLabel || "Payment";
    this.orderPaymentButtonTooltip =
      props.orderPaymentButtonTooltip || "Open Order Payment";
    this.deleteButtonLabel = props.deleteButtonLabel || "Delete";
    this.deleteButtonTooltip = props.deleteButtonTooltip || "Delete Order";
    this.payButtonLabel = props.payButtonLabel || "New Payment";
    this.payButtonTooltip =
      props.payButtonTooltip ||
      "Submit new payment to activate the storage order";

    this.state = this.populateState(props);
    logDebug("OrderDetails STATE");
    logDebug(this.state);

    this.onDialogClose = this.onDialogClose.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onOrderPayment = this.onOrderPayment.bind(this);
    this.onOrderPaymentClose = this.onOrderPaymentClose.bind(this);
    this.onOrderItemActionUpdate = this.onOrderItemActionUpdate.bind(this);
    this.handleOrderUpdate = this.handleOrderUpdate.bind(this);
    this.onOrderUpdateSuccess = this.onOrderUpdateSuccess.bind(this);
    this.onOrderUpdateError = this.onOrderUpdateError.bind(this);
    this.onDeleteOrder = this.onDeleteOrder.bind(this);
    this.isValidAction = this.isValidAction.bind(this);
    this.onDeleteOrderNoOption = this.onDeleteOrderNoOption.bind(this);
    this.onDeleteOrderYesOption = this.onDeleteOrderYesOption.bind(this);
  }

  populateState(props: IOrderProps) {
    let superState = super.populateState(props);
    let state: IOrderState = {
      ...superState,
      orderActions: [],
      showOrderPayment: false,
      showDeleteOrderWarning: false,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    };
    let currentOrder = new OrderEntity();
    state.currentEntity = currentOrder;
    state.originalEntity = new OrderEntity();
    return state;
  }

  onDialogClose(event: {}, reason: "backdropClick" | "escapeKeyDown") {
    if (reason === "backdropClick") {
      return;
    }
    this.onEntityDetailsClose();
  }

  onCancel(): void {
    this.onEntityDetailsClose();
  }

  onOrderPayment(): void {
    this.setState({ ...this.state, showOrderPayment: true } as IOrderState);
  }

  onOrderPaymentClose(): void {
    this.setState({ ...this.state, showOrderPayment: false } as IOrderState);
  }

  onDeleteOrderNoOption(): void {
    this.setState({
      ...this.state,
      showDeleteOrderWarning: false,
    } as IOrderState);
  }

  onDeleteOrderYesOption(): void {
    this.handleDeleteEntity();
  }

  multipleItems(): boolean {
    let rc = false;
    if (
      this.state.currentEntity.orderItems &&
      this.state.currentEntity.orderItems.length > 1
    ) {
      rc = true;
    }
    return rc;
  }

  getUpdatedActions(): Array<OrderItemAction> {
    const updatedActions = this.state.orderActions.filter((action) => {
      const orderItem: IOrderItem = this.state.currentEntity.orderItems.find(
        (item: IOrderItem) => item.id === action.orderItemId
      );
      return (
        orderItem !== undefined &&
        orderItem.shipmentItem !== null &&
        (orderItem.shipmentItem.status !== action.shippingStatus ||
          (orderItem.storageItem?.status || StorageStatus.DRAFT) !==
            action.storageStatus)
      );
    });
    return updatedActions;
  }

  updateTrackingNumber(
    orderItemActions: Array<OrderItemAction>
  ): Array<OrderItemAction> {
    return orderItemActions.map((action) => {
      const orderItem: IOrderItem = this.state.currentEntity.orderItems.find(
        (item: IOrderItem) => item.id === action.orderItemId
      );
      if (
        orderItem !== undefined &&
        ((action.storageStatus === StorageStatus.DRAFT &&
          action.shippingStatus !== ShippingStatus.DELIVERED &&
          orderItem.shipmentItem.trackingNumber === action.trackingNumber) ||
          (action.storageStatus !== StorageStatus.DRAFT &&
            orderItem.storageItem?.trackingNumber === action.trackingNumber))
      ) {
        action.trackingNumber = null;
      }
      return action;
    });
  }

  isSaveEnabled(): boolean {
    return this.getUpdatedActions().length > 0;
  }

  validateTrackingNumber(trackingNumber: string): boolean {
    return /^(?:[A-Z]{2}\d{7}(?:GB)?|[A-Z]{4}\d{10}|\d{12}|[A-Z]{2}\d{9}[A-Z]{2})$/.test(
      trackingNumber.trim().toUpperCase()
    );
  }

  validateNotes(notes: string): boolean {
    return /^[a-zA-Z0-9\s.,'-]{0,250}$/.test(notes.trim());
  }

  isValidAction(orderItemAction: OrderItemAction): boolean {
    if (
      (this.state.currentEntity.type === OrderType.STORAGE &&
        orderItemAction.shippingStatus === ShippingStatus.LABELS_SHIPPED) ||
      (this.state.currentEntity.type === OrderType.HOME &&
        orderItemAction.shippingStatus === ShippingStatus.PICKUP_COMPLETED)
    ) {
      if (
        orderItemAction.trackingNumber === undefined ||
        orderItemAction.trackingNumber === null
      ) {
        this.displayMessage(
          SnackbarComponentVariant.error,
          `Please enter a valid tracking number for item ${orderItemAction.itemLabel}`,
          false
        );
        return false;
      }
      if (!this.validateTrackingNumber(orderItemAction.trackingNumber)) {
        this.displayMessage(
          SnackbarComponentVariant.error,
          `Please enter a valid tracking number for item ${orderItemAction.itemLabel}`,
          false
        );
        return false;
      }
      this.trackingNumbers.push(orderItemAction.trackingNumber);
    }
    if (
      orderItemAction.shippingStatus === ShippingStatus.DELIVERED &&
      this.state.currentEntity.type === OrderType.STORAGE
    ) {
      if (
        orderItemAction.trackingNumber === undefined ||
        orderItemAction.trackingNumber === null
      ) {
        this.displayMessage(
          SnackbarComponentVariant.error,
          `Please enter a valid tracking number for item ${orderItemAction.itemLabel}`,
          false
        );
        return false;
      }
      if (!this.validateTrackingNumber(orderItemAction.trackingNumber)) {
        this.displayMessage(
          SnackbarComponentVariant.error,
          `Please enter a valid tracking number for item ${orderItemAction.itemLabel}`,
          false
        );
        return false;
      }
      this.trackingNumbers.push(orderItemAction.trackingNumber);
    }
    if (!this.validateNotes(orderItemAction.note || "")) {
      this.displayMessage(
        SnackbarComponentVariant.error,
        `Please enter valid notes value for item ${orderItemAction.itemLabel}. Notes may contain only letters, numbers, spaces and symbols ,.-'`,
        false
      );
      return false;
    }
    return true;
  }

  validateOrderItemActions(orderItemActions: Array<OrderItemAction>): boolean {
    this.trackingNumbers = [];
    let validationResult = orderItemActions.every(this.isValidAction);
    if (validationResult) {
      const containsDuplicates =
        this.trackingNumbers.length !== new Set(this.trackingNumbers).size;
      if (containsDuplicates) {
        this.displayMessage(
          SnackbarComponentVariant.error,
          `Found duplicate tracking numbers`,
          false
        );
        validationResult = false;
      }
    }
    this.trackingNumbers = [];
    return validationResult;
  }

  handleOrderUpdate(): void {
    const orderItemActions = this.updateTrackingNumber(
      this.getUpdatedActions()
    );
    if (this.validateOrderItemActions(orderItemActions)) {
      this.updateOrder(orderItemActions);
    }
  }

  onDeleteOrder(): void {
    this.setState({
      ...this.state,
      showDeleteOrderWarning: true,
    } as IOrderState);
  }

  ///////////////////////
  //// API callbacks ////
  ///////////////////////
  onOrderUpdateSuccess(data: any): void {
    let currentState = this.state;
    currentState.currentEntity = data.data;
    this.setState(currentState);
    if (this.onUpdate) {
      this.onUpdate(data.data);
    }
    this.displayMessage(
      SnackbarComponentVariant.success,
      "Order Updated",
      true
    );
  }
  onOrderUpdateError(message: string, data: any): void {
    this.displayMessage(SnackbarComponentVariant.error, message, false);
  }
  // OVERRIDE
  onEntityGetSuccess(data: any): void {
    const order: IOrder = data.data;
    let orderItemActions = (data.data as IOrder).orderItems.map((item) => {
      let orderItemAction: OrderItemAction = new OrderItemActionEntity();
      orderItemAction.orderItemId = item.id;
      orderItemAction.itemId = item.itemId;
      orderItemAction.itemLabel = item.itemLabel;
      if (item.shipmentItem !== null) {
        orderItemAction.shipmentItemId = item.shipmentItem?.id;
        orderItemAction.shippingStatus = item.shipmentItem?.status;
        if (order.type == OrderType.STORAGE) {
          if (
            item.shipmentItem.status === ShippingStatus.PICKUP_COMPLETED ||
            item.shipmentItem.status === ShippingStatus.DELIVERED
          ) {
            if (item.storageItem) {
              orderItemAction.trackingNumber = item.storageItem.trackingNumber;
            } else {
              orderItemAction.trackingNumber = "";
            }
          } else {
            orderItemAction.trackingNumber = item.shipmentItem?.trackingNumber;
          }
          orderItemAction.actionDate = this.getDate(item.shipmentItem);
          if (item.shipmentItem.status === ShippingStatus.LABELS_DELIVERED) {
            orderItemAction.useTheSameDateAndTime = true;
          }
        } else {
          if (item.shipmentItem.status === ShippingStatus.REQUESTED) {
            orderItemAction.trackingNumber = "";
          }
          orderItemAction.actionDate = this.getDate(item.shipmentItem);
          if (item.shipmentItem.status === ShippingStatus.REQUESTED) {
            orderItemAction.useTheSameDateAndTime = true;
          }
        }
      }
      if (item.storageItem !== null) {
        orderItemAction.storageStatus =
          item.storageItem?.status || StorageStatus.DRAFT;
      }
      return orderItemAction;
    });
    let currentState = this.state;
    currentState.orderActions = orderItemActions;
    this.setState(currentState);
    super.onEntityGetSuccess(data);
  }
  ///////////////////////////
  //// END API callbacks ////
  ///////////////////////////

  // OVERRIDE
  validateEntity(order: IOrder): boolean {
    return true;
  }

  getDate(shipmentItem: IShipmentItem): Date | null {
    let date = new Date();
    if (
      shipmentItem.status === ShippingStatus.PICKUP_REQUESTED &&
      shipmentItem.requestedPickup
    ) {
      date = shipmentItem.requestedPickup;
    }
    if (
      shipmentItem.status === ShippingStatus.PICKUP_SCHEDULED &&
      shipmentItem.scheduledPickup
    ) {
      date = shipmentItem.scheduledPickup;
    }
    return date;
  }

  getOrderItemAction(id: string): OrderItemAction {
    return (
      this.state.orderActions.find(
        (orderAction) => orderAction.orderItemId === id
      ) || new OrderItemActionEntity()
    );
  }

  onOrderItemActionUpdate(orderItemAction: OrderItemAction): void {
    const index = this.state.orderActions.findIndex(
      (orderAction) => orderAction.orderItemId === orderItemAction.orderItemId
    );
    if (index !== -1) {
      let currentOrderItemActions = this.state.orderActions;
      currentOrderItemActions[index].actionDate = orderItemAction.actionDate;
      // handle date updates
      if (
        (currentOrderItemActions[index].shippingStatus ===
          ShippingStatus.PICKUP_REQUESTED ||
          currentOrderItemActions[index].shippingStatus ===
            ShippingStatus.PICKUP_COMPLETED) &&
        orderItemAction.useTheSameDateAndTime
      ) {
        // set this date to all empty order actions
        currentOrderItemActions.forEach((action) => {
          if (
            action.itemId !== currentOrderItemActions[index].itemId &&
            action.useTheSameDateAndTime
          ) {
            action.actionDate = orderItemAction.actionDate;
          }
        });
      }
      currentOrderItemActions[index] = orderItemAction;
      this.setState({
        ...this.state,
        orderActions: currentOrderItemActions,
      } as IOrderState);
    }
  }

  updateOrder(orderItemActions: Array<OrderItemAction>): void {
    let request: OrderUpdateRequest = new OrderUpdateRequestEntity();
    request.orderId = this.state.currentEntity.id;
    request.orderItemActions = orderItemActions;

    this.httpService.put(
      this.updateOrderURL,
      request,
      this.onOrderUpdateSuccess,
      this.onOrderUpdateError,
      this.setDisplaySpinner
    );
  }

  renderOrderPayment() {
    if (this.state.showOrderPayment) {
      const paymentProps: IPaymentProps = {
        detailsMode: Mode.update,
        entityId: this.state.currentEntity.id,
        entityName: "payment",
        entityTitle: "Payments",
        getItemURL: "/payment/order",
        httpService: this.httpService,
        isAdmin: this.isAdmin,
        addPaymentRefundURL: "/payment/refund",
        isShowing: this.state.showOrderPayment,
        itemTitle: "Payment",
        onEntityDetailsClose: this.onOrderPaymentClose,
        setDisplaySpinner: this.setDisplaySpinner,
        updateURL: "/payment",
        windowWidth: this.state.windowWidth,
        windowHeight: this.state.windowHeight,
        styles: this.effectiveStyles,
      };
      return <PaymentDetails {...paymentProps} />;
    } else {
      return <></>;
    }
  }

  renderDeleteOrderdWarningDialog() {
    const title = "Delete Storage Order";
    const message = `You are about to delete Storage Order ${this.state.currentEntity.orderNumber}. Click Yes to proceed`;
    return (
      <Alert
        isShowing={this.state.showDeleteOrderWarning}
        title={title}
        onOption1={this.onDeleteOrderNoOption}
        option1Label="No"
        onOption2={this.onDeleteOrderYesOption}
        option2Label="Yes"
        styles={this.effectiveStyles}
      >
        <div style={this.effectiveStyles.PackableAlertDialogBody}>
          <Typography>{message}</Typography>
        </div>
      </Alert>
    );
  }

  render() {
    return (
      <div
        className="OrderDetailsContainer"
        style={this.effectiveStyles.OrderDetailsContainer}
      >
        <Dialog
          className="OrderDetailsDialog"
          sx={this.effectiveStyles.OrderDetailsDialog}
          open={this.isShowing}
          onClose={this.onDialogClose}
          aria-labelledby="form-dialog-title"
          slotProps={{
            transition: this.entityId
              ? {
                  timeout: 600,
                  onEntered: this.loadEntity,
                }
              : {},
          }}
          maxWidth={"md"}
          fullScreen={
            this.state.windowWidth < 500 //|| this.state.windowHeight < 500
          }
        >
          <DialogTitle
            className="OrderDetailsDialogTitle"
            sx={this.effectiveStyles.OrderDetailsDialogTitle}
            id="form-dialog-title"
          >
            <Grid
              className="OrderDetailsDialogTitleContainer"
              sx={this.effectiveStyles.OrderDetailsDialogTitleContainer}
              container
            >
              <Box
                className="OrderDetailsTitle"
                sx={this.effectiveStyles.OrderDetailsTitle}
              >
                {`Order ${this.state.currentEntity.orderNumber || ""}`}
              </Box>
              <Box>
                <Typography variant="body2">
                  {this.state.currentEntity.type === OrderType.STORAGE
                    ? "Pickup storage items at this address"
                    : "Return storage items to this address"}
                </Typography>
              </Box>
            </Grid>
          </DialogTitle>
          <DialogContent
            className="OrderDetailsDialogContent"
            sx={this.effectiveStyles.OrderDetailsDialogContent}
          >
            <SnackbarComponent
              openFlag={this.state.displaySnackbar}
              variant={this.state.snackbarVariant}
              message={this.state.snackbarMessage}
              onClose={this.handleCloseSnackbar}
            />
            <div
              style={
                this.state.displaySpinner
                  ? this.effectiveStyles.OrderDetailsShowSpinner
                  : this.effectiveStyles.OrderDetailsHideSpinner
              }
            >
              <CircularProgress />
            </div>
            {this.renderOrderPayment()}
            {this.renderDeleteOrderdWarningDialog()}
            <Grid
              container
              className="OrderDetailsDialogContentContainer"
              sx={this.effectiveStyles.OrderDetailsDialogContentContainer}
            >
              <OrderHeader
                order={this.state.currentEntity}
                styles={this.effectiveStyles}
              />
              <Grid
                className="OrderDetailsDialogSingleItemRowContainer"
                sx={
                  this.effectiveStyles.OrderDetailsDialogSingleItemRowContainer
                }
              >
                <Grid
                  className="OrderDetailsDialogFullWidthTextFieldContainer"
                  sx={
                    this.effectiveStyles
                      .OrderDetailsDialogFullWidthTextFieldContainer
                  }
                >
                  <Grid
                    className="OrderDetailsDialogFullWidthTextField"
                    sx={
                      this.effectiveStyles.OrderDetailsDialogFullWidthTextField
                    }
                  >
                    <Typography sx={{ fontWeight: 700 }} variant="body2">
                      {`Order Status: ${this.state.currentEntity.status}`}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              {this.state.currentEntity.paymentStatus ===
                PaymentStatus.FAILED && (
                <Grid
                  className="OrderDetailsDialogSingleItemRowContainer"
                  sx={
                    this.effectiveStyles
                      .OrderDetailsDialogSingleItemRowContainer
                  }
                >
                  <Grid
                    className="OrderDetailsDialogFullWidthTextFieldContainer"
                    sx={
                      this.effectiveStyles
                        .OrderDetailsDialogFullWidthTextFieldContainer
                    }
                  >
                    <Grid
                      className="OrderDetailsDialogFullWidthTextField"
                      sx={
                        this.effectiveStyles
                          .OrderDetailsDialogFullWidthTextField
                      }
                    >
                      <Typography sx={{ fontWeight: 700 }} variant="body2">
                        {`Payment Status: ${this.state.currentEntity.paymentStatus}`}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {this.state.currentEntity.orderItems
                .sort((a: IOrderItem, b: IOrderItem) =>
                  a.itemLabel.localeCompare(b.itemLabel)
                )
                .map((orderItem: IOrderItem) => (
                  <OrderItem
                    orderItem={orderItem}
                    orderItemAction={this.getOrderItemAction(orderItem.id)}
                    onOrderItemActionUpdate={this.onOrderItemActionUpdate}
                    multipleItems={this.multipleItems()}
                    isAdmin={this.isAdmin}
                    dimensionUnit={this.state.currentEntity.dimensionUnit}
                    weigthUnit={this.state.currentEntity.weightUnit}
                    styles={this.effectiveStyles}
                  />
                ))}
            </Grid>
          </DialogContent>
          <DialogActions
            className="OrderDetailsDialogActions"
            sx={this.effectiveStyles.OrderDetailsDialogActions}
          >
            <Grid
              container
              className="OrderDetailsDialogActionsContainer"
              sx={this.effectiveStyles.OrderDetailsDialogActionsContainer}
            >
              <Tooltip
                title={`${
                  this.isSaveEnabled()
                    ? this.cancelButtonTooltip
                    : this.closeButtonTooltip
                }`}
              >
                <Button
                  className="OrderDetailsDialogActionsCancelButton"
                  sx={
                    this.effectiveStyles.OrderDetailsDialogActionsCancelButton
                  }
                  onClick={this.onCancel}
                  color={
                    this.effectiveStyles.OrderDetailsDialogActionsCancelButton
                      .muiColor
                  }
                  variant={
                    this.effectiveStyles.OrderDetailsDialogActionsCancelButton
                      .muiVariant
                  }
                >
                  {this.isSaveEnabled()
                    ? this.cancelButtonLabel
                    : this.closeButtonLabel}
                </Button>
              </Tooltip>
              {this.isAdmin &&
                this.state.currentEntity.type !== OrderType.HOME && (
                  <Tooltip title={this.orderPaymentButtonTooltip}>
                    <Button
                      className="OrderDetailsDialogActionsOrderPaymentButton"
                      sx={
                        this.effectiveStyles
                          .OrderDetailsDialogActionsOrderPaymentButton
                      }
                      onClick={this.onOrderPayment}
                      color={
                        this.effectiveStyles
                          .OrderDetailsDialogActionsOrderPaymentButton.muiColor
                      }
                      variant={
                        this.effectiveStyles
                          .OrderDetailsDialogActionsOrderPaymentButton
                          .muiVariant
                      }
                    >
                      {this.orderPaymentButtonLabel}
                    </Button>
                  </Tooltip>
                )}
              {this.state.currentEntity.status === OrderStatus.DRAFT &&
                this.state.currentEntity.paymentStatus ===
                  PaymentStatus.FAILED && (
                  <Tooltip title={this.deleteButtonTooltip}>
                    <Button
                      className="OrderDetailsDialogActionsDeleteButton"
                      sx={
                        this.effectiveStyles
                          .OrderDetailsDialogActionsDeleteButton
                      }
                      onClick={this.onDeleteOrder}
                      color={
                        this.effectiveStyles
                          .OrderDetailsDialogActionsDeleteButton.muiColor
                      }
                      variant={
                        this.effectiveStyles
                          .OrderDetailsDialogActionsDeleteButton.muiVariant
                      }
                    >
                      {this.deleteButtonLabel}
                    </Button>
                  </Tooltip>
                )}
              {!this.isAdmin &&
                this.state.currentEntity.status === OrderStatus.DRAFT &&
                this.state.currentEntity.paymentStatus ===
                  PaymentStatus.FAILED && (
                  <Tooltip title={this.payButtonTooltip}>
                    <Button
                      className="OrderDetailsDialogActionsPayButton"
                      sx={
                        this.effectiveStyles.OrderDetailsDialogActionsPayButton
                      }
                      onClick={this.onDeleteOrder}
                      color={
                        this.effectiveStyles.OrderDetailsDialogActionsPayButton
                          .muiColor
                      }
                      variant={
                        this.effectiveStyles.OrderDetailsDialogActionsPayButton
                          .muiVariant
                      }
                    >
                      {this.payButtonLabel}
                    </Button>
                  </Tooltip>
                )}
              {this.isSaveEnabled() && (
                <Tooltip title={this.submitButtonTooltip}>
                  <Button
                    className="OrderDetailsDialogActionsSaveButton"
                    sx={
                      this.effectiveStyles.OrderDetailsDialogActionsSaveButton
                    }
                    onClick={this.handleOrderUpdate}
                    color={
                      this.effectiveStyles.OrderDetailsDialogActionsSaveButton
                        .muiColor
                    }
                    variant={
                      this.effectiveStyles.OrderDetailsDialogActionsSaveButton
                        .muiVariant
                    }
                  >
                    {this.submitButtonLabel}
                  </Button>
                </Tooltip>
              )}
            </Grid>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default OrderDetails;
